module.exports = __webpack_public_path__ + "IMG-6907.jpg?02b4fbdefdb688e214a1365e96b60cde";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IMG-6907.jpg
// module id = 214
// module chunks = 0